const NoReceivedHistory = ({ item }) => {
  return (
    <div className="pl-4 pt-4 relative">
      <p className="cy-history-gray-dot"></p>
      <p className="cy-history-gray-line"></p>
      <p className="cy-history-no-received">Cylinder Not Received yet!</p>
    </div>
  );
};

export default NoReceivedHistory;
